import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

import { useChargebeePaymentElement } from './hooks/use-chargebee-payment-element';
import { AddressElement } from '../../Checkout/components/AddressElement/AddressElement';
import { PayButton } from '../../Checkout/components/PaymentForm/components/PayButton/PayButton';
import { useShowTaxCalculationFields } from '../../Checkout/hooks/use-show-tax-calculation-fields';
import { PaymentElementContainer } from '../../Checkout/components/PaymentElementContainer/PaymentElementContainer';

export function ChargebeePaymentElement() {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const { useTaxCalculationField } = useShowTaxCalculationFields();
  const { ref, showPayButton, handlePaymentButtonClick, AddressElementRef } =
    useChargebeePaymentElement();

  return (
    <PaymentElementContainer
      content={
        <Stack spacing={1}>
          <div id="payment-component" ref={ref} style={{ width: '100%' }} />
          {useTaxCalculationField && (
            <AddressElement ref={AddressElementRef} zipOnly isSubscription />
          )}
        </Stack>
      }
    >
      {showPayButton && (
        <PayButton onClick={handlePaymentButtonClick} buttonText={t('subscribeAndPay')} />
      )}
    </PaymentElementContainer>
  );
}
